export const VIEWPORT_TYPES = {
  RESPONSIVE: 'width=device-width, initial-scale=1.0',
  // No initial-scale: iOS/Android auto-fit the zoom to the fixed width (like "Request desktop site");
  // pinch-zoom stays enabled so 1280px content is readable on a phone.
  DESKTOP: 'width=1280',
};

export const DESKTOP_ONLY_ROUTES = [
  '/ppc/analytics/campaign',
  '/ppc/analytics/portfolio',
  '/ppc/analytics/ad-group',
  '/ppc/analytics/target',
  '/ppc/analytics/negative-target',
  '/ppc/analytics/search-term',
  '/ppc/analytics/ads',
  '/ppc/history',
  '/ppc/search-terms',
  '/ppc/targeting-report',
  '/ppc/traffic-conversion',
  '/ppc/traffic-conversion-v2',
  '/ppc/unified-report',
  '/ppc/unified-report-v2',
  '/ppc/unified-search-terms',
  // '/settings/connections',
];

export function isDesktopOnlyRoute(path) {
  return DESKTOP_ONLY_ROUTES.some((route) => path === route || path.startsWith(`${route}/`));
}

function ensureViewportStyles() {
  if (document.getElementById('viewport-desktop-style')) return;

  const style = document.createElement('style');
  style.id = 'viewport-desktop-style';
  style.innerHTML = `
    html, body {
      width: 100% !important;
      overflow-x: hidden !important;
      min-width: auto !important;
      margin: 0 !important;
      padding: 0 !important;
    }
  `;
  document.head.appendChild(style);
}

export function applyViewportMeta(content) {
  let viewportMeta = document.querySelector('meta[name="viewport"]');

  if (!viewportMeta) {
    viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    document.head.appendChild(viewportMeta);
  }

  viewportMeta.content = content;

  // Force a resize event so layout state depending on useWindowSize (@layouts) re-evaluates.
  requestAnimationFrame(() => {
    window.dispatchEvent(new Event('resize'));
  });

  ensureViewportStyles();

  return content;
}
